import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-lock-hinweis',
  templateUrl: './lock-hinweis.component.html',
  styleUrls: ['./lock-hinweis.component.scss'],
  standalone: false
})
export class LockHinweisComponent implements OnInit {
    ngOnInit(): void {
        // console.log(this.data);
    }

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

    onReload() {
        window.location.reload();
    }
}
